import { motion } from "framer-motion"
import styled from "styled-components"

export const StyledPagination = styled(motion.div)`
  display: flex;
  justify-content: center;
  width: 100%;
  margin-top: 42px;
`
